import { createNewDate } from "../../../APIs/date";
import { modelValid } from "../../../../Models/modelSystemG"
import { panelController } from "../../../../stores/service"

export class detectDevice {
    token = '';
    model = '';
    documentUser = [];
    user = "";
    NewdataDlock = {};
    metadata;
    dataUser = {};

    constructor(dataUser,documentUser, user) {

        this.dataUser = dataUser
        this.user = user;
        this.documentUser = documentUser;


    }

    validUsvalidate_membershiper(){
        if (this.dataUser.service.membresia) {
            return false;
        }
    }




        async ActNotfAndroid() {
        let date = await createNewDate("America/Mexico_City");
        try {
            this.metadata = await new Promise((resolve, reject) => {

                window.mostrarRespuesta = (data) => {
                    try {
                        const parsed = JSON.parse(data);
                        resolve(parsed);
                    } catch (e) {
                        reject(new Error('Error al parsear respuesta: ' + e.message));
                    }
                };

                if (window.androidInterface) {
                    window.androidInterface.procesarDatos();
                } else {
                    reject(new Error('Interfaz Android no disponible Svelte'));
                }
            });



            if (this.metadata.token == "") {
                return {status:false,error:this.metadata.token};
            }

            this.token = this.metadata.token;
            this.model = this.metadata.device;
            this.NewdataDlock = {
                active: true,
                platform: "Android",
                token: this.token,
                model: this.model,
                version: "",
                lastVerified: date.currentDate,
            }
            return {status:true,error:false};

        } catch (error) {

            return {status:false,error:error};

        }

    }

    async act(documentUser) {
        panelController.update((service) => {
            service.service.tableadmins = documentUser;
            return service;

        });
        let update = await modelValid({
            doc: 'updateDoc'
        });
        
        return true;
    }
    async creatingDataBlock() {
        
        this.index = this.documentUser.findIndex(
            (users) => users.email === this.user
        );

        if (this.index == -1) {
            return false
        }

        if (this.documentUser[this.index].hasOwnProperty("notificaciones")) {
            this.documentUser[this.index].notificaciones.push(this.NewdataDlock)
        } else {
            this.documentUser[this.index].notificaciones = [this.NewdataDlock]
        }

        return await this.act(JSON.parse(JSON.stringify(this.documentUser)));

    }
}
